var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.hidden
    ? _c("v-breadcrumbs", {
        staticClass: "flex-shrink-1 pa-0",
        staticStyle: { height: "18px" },
        attrs: { items: _vm.BreadcrumbList, divider: ">" },
        scopedSlots: _vm._u(
          [
            {
              key: "item",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c(
                    "v-breadcrumbs-item",
                    {
                      attrs: {
                        disabled: item.disabled,
                        to: item.disabled ? null : item.to,
                        "active-class": item.disabled
                          ? "text--secondary "
                          : "primary--text",
                      },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "text-caption",
                          style: {
                            cursor: item.disabled ? "default " : "pointer ",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t(item.text)))]
                      ),
                    ]
                  ),
                ]
              },
            },
            {
              key: "divider",
              fn: function () {
                return [
                  _c("span", { staticClass: "text-caption" }, [
                    _vm._v(_vm._s(">")),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          3024624029
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }